/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UserStateOfUse = {
    InAdding: 'InAdding',
    InEditing: 'InEditing',
    NoActivationSent: 'NoActivationSent',
    ActivationPending: 'ActivationPending',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    Archived: 'Archived',
    Deleted: 'Deleted'
} as const;
export type UserStateOfUse = typeof UserStateOfUse[keyof typeof UserStateOfUse];


export function UserStateOfUseFromJSON(json: any): UserStateOfUse {
    return UserStateOfUseFromJSONTyped(json, false);
}

export function UserStateOfUseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserStateOfUse {
    return json as UserStateOfUse;
}

export function UserStateOfUseToJSON(value?: UserStateOfUse | null): any {
    return value as any;
}

/**
 * Check if a given object implements the UserStateOfUse interface.
 */
 export function instanceOfUserStateOfUse(value: any): value is UserStateOfUse {
    return Object.values(UserStateOfUse).includes(value)
}

